export default {"src":"/_next/static/media/linkedin-logo.3e1709c7.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};